<div *ngIf="dataUser || showDetailUser == true" id="userDetail">
	<section class="main-side-nav" [ngClass]="{hideOnMobile:sideNavBarVisibilityService.hideOnMobile==true, 'main-side-nave-theme': themeService.theme != 'default'}">
		<section class="container admin-dashboard-details professionals-details-container">
			<section class="template-section-title">
				<div class="breadcrumb-container">
					<span>Admin <i class="fa fas fa-chevron-right"></i></span>
					<app-breadcrumb [pageName]="'Professionals Details'" [isTopLevel]="true"></app-breadcrumb>
				</div>
				<div class="title-container">
					<h1>Professionals Details</h1>
				</div>
			</section>

			<section class="user-dashboard">
				<div class="user-name">
					<h2 class="user-name"><!-- Data --></h2>
				</div>
			</section>
			<section class="user-data-info">
				<section class="team">
					<div class="title-section"><!-- Data --></div>
					<div class="table-responsive admin-dashboard-table">
						<table class="table table-bordered table-hover">
							<thead>
                                <tr>
                                    <th scope="col">First Name</th>
                                    <th scope="col">Last Name</th>
                                    <th scope="col">Email</th>
                                    <th scope="col">Role</th>
                                    <th scope="col">Client Accounts</th>
                                </tr>
							</thead>
							<tbody>
                                <tr>
                                    <td><!-- Data --></td>
                                    <td><!-- Data --></td>
                                    <td><!-- Data --></td>
                                    <td><!-- Data --></td>
                                    <td><!-- Data --></td>
                                </tr>
							</tbody>
						</table>
					</div>
				</section>
				<section class="client">
					<div class="title-section"><!-- Data --></div>
					<div class="table-responsive admin-dashboard-table">
						<table class="table table-bordered table-hover">
							<thead>
							<tr>
								<th scope="col">First Name</th>
								<th scope="col">Last Name</th>
								<th scope="col">Email</th>
								<th scope="col">joined</th>
								<th scope="col">Last Log in</th>
							</tr>
							</thead>
							<tbody>
							<tr>
								<td><!-- Data --></td>
								<td><!-- Data --></td>
								<td><!-- Data --></td>
								<td><!-- Data --></td>
								<td><!-- Data --></td>
							</tr>
							</tbody>
						</table>
					</div>
				</section>
			</section>
			<input type="button" class="btn btn-primary back-btn" value="Back" (click)="goBack()">
		</section>
	</section>
</div>
